import { __assign, __extends } from "tslib";
import * as ModelTraverser from '../Model/ModelGraphTraverser';
import { ValidationDisplayMode } from './Misc';
import { RelationType } from '../Model/Misc';
var ObjectRecursionState = /** @class */ (function (_super) {
    __extends(ObjectRecursionState, _super);
    function ObjectRecursionState(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.stack = [];
        return _this;
    }
    ObjectRecursionState.prototype.add = function (object, relationType) {
        this.current = __assign(__assign({}, object), { childLists: [], childObjects: [], valueObjects: [] });
        if (relationType === RelationType.ChildObject) {
            this.parent.childObjects.push(this.current);
        }
        else if (relationType === RelationType.ValueObject) {
            this.parent.valueObjects.push(this.current);
        }
        else {
            this.parent.childLists.push(this.current);
        }
    };
    ObjectRecursionState.prototype.pushState = function () {
        this.stack.push({ parent: this.parent, current: this.current });
        this.parent = this.current;
    };
    ObjectRecursionState.prototype.popState = function () {
        var prevState = this.stack.pop();
        this.current = prevState.current;
        this.parent = prevState.parent;
    };
    return ObjectRecursionState;
}(ModelTraverser.RecursionState));
export function getValidationSummary(model, displayMode) {
    var _a;
    var root = { model: undefined, objectDisplayInfo: [], isValid: true, childLists: [], propertyRules: [], childObjects: [], valueObjects: [] };
    var state = new ObjectRecursionState(root);
    var models;
    var isArray = model instanceof Array;
    if (isArray) {
        models = model;
    }
    else {
        models = [model];
    }
    for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
        var model_1 = models_1[_i];
        ModelTraverser.traverseItems(model_1, state, function (item, state, relationType) {
            if (!item.isValid) {
                state.add(item.validator.getBrokenRules(displayMode || ValidationDisplayMode.Always), relationType);
            }
        });
    }
    return isArray ? root.childLists : ((_a = root.childLists[0]) !== null && _a !== void 0 ? _a : null);
}
